module.exports = "/v2/pages/dashboard/dist/82f60bd0b94a1ed68b1e6e309ce2e8c3.svg";